import React from "react";
import { useTranslation } from "react-i18next";
import { Buttons } from "components";

// S6 ส่งการจองแล้ว: รหัสจอง + ปุ่มกลับ (ข้อความรอตรวจ 24 ชม. อยู่ในการ์ดใบจองหน้ากิจกรรม)
const DoneStep = ({ code, onBack }) => {
  const { t } = useTranslation(["seat"]);
  return (
    <div className="done_block">
      <div className="done_title">
        {t("Booking submitted", { ns: "seat" })}
        {code && (
          <>
            <br />
            {t("Booking code", { ns: "seat" })} {code}
          </>
        )}
      </div>
      <div className="done_btn">
        <Buttons.BgStandard height="48px" label={t("Back", { ns: "seat" })} onClick={onBack} />
      </div>
    </div>
  );
};

export default DoneStep;
